<template>
  <div class="lm-new-row"></div>
</template>

<script>
export default {
  name: "WorkspaceNewRow"
};
</script>

<style>
.lm-new-row {
  width: 880px;
  height: 50px;
  cursor: pointer;
  border: 1px dashed black;
}
</style>
